import React, { useContext } from "react"
import { api } from "../lib/api"

export const ApiContext = React.createContext(api)

export function useApi() {
  return useContext(ApiContext)
}
